/** Candidate pages render authentication failures in their own flow. */
export const isCandidateAuthFailureInline = (pathname: string): boolean =>
  pathname.startsWith('/web-interview') ||
  pathname.startsWith('/web-call') ||
  pathname.startsWith('/feedback') ||
  pathname.startsWith('/practice-completed') ||
  pathname.startsWith('/reschedule') ||
  pathname.startsWith('/opt-out') ||
  pathname.startsWith('/accommodation-request') ||
  pathname.startsWith('/rejection-review') ||
  pathname.startsWith('/candidate/') ||
  pathname.startsWith('/hm-intake');
